import _ from "underscore";
import { getWindow } from "ssr-window";
import {
  isMobile as isDeviceMobile,
  isIE,
  isSafari,
  isMobileSafari,
} from "react-device-detect";

import config from "@/utils/config";
import { api } from "@/utils/api";
import { libraryTypeEnum } from "@/utils/enum";

// parse html query params
export const parse = (name, url) => {
  name = name.replace(/[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

// isEmpty
export const isEmpty = (obj) => {
  if (typeof obj === "undefined" || obj === null) {
    return true;
  }
  if (typeof obj === "string" && trim(obj) === "") {
    return true;
  }
  return false;
};

//delete left and right space
export const trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
};

// string to date
export function stringToDate(time) {
  if (!time) return null;
  const date = time.replace(/-/g, "/");
  return new Date(date);
}

// prevent click event
export const preventClickEvent = (id) => {
  if (document) {
    document.getElementById(id).addEventListener(
      "click",
      (e) => {
        e.stopPropagation();
        e.preventDefault();
      },
      true
    );
  }
};

// prevent click event
export const shouldMovePageDirectly = (id) => {
  if (document) {
    document.getElementById(id).addEventListener(
      "click",
      (e) => {
        if (getWindow().ExternalReactRenderer?.shouldMovePageDirectly) {
          getWindow()
            .ExternalReactRenderer.shouldMovePageDirectly()
            .catch(() => {
              e.stopPropagation();
              e.preventDefault();
            });
        }
      },
      true
    );
  }
};

// scroll to top
export const scrollTop = () => {
  if (document && document.getElementById("content-main-container")) {
    document.getElementById("content-main-container").scrollTop = 0;
  }
};

// is mini size
export const isMiniSize = () => {
  return document.body.offsetWidth <= config.mobileMaxWidth;
};

// is mobile
export const isMobile = () => {
  return isDeviceMobile;
};

//  is IE
export const isIEBrowser = () => {
  return isIE;
};

// is safari
export const isSafariBrowser = () => {
  return isSafari || isMobileSafari;
};

// debounce
export const debounce = (func, wait = 300) => {
  return _.debounce(func, 300);
};

// append script
export const appendScript = (scriptToAppend) => {
  const scripts = document.getElementsByTagName("script");
  if (
    _.filter(scripts, (element) => element.src.indexOf(scriptToAppend) !== -1)
      .length === 0
  ) {
    const script = document.createElement("script");
    script.src = scriptToAppend;
    script.async = true;
    document.body.appendChild(script);
  }
};

// loop dom element
export const getChildrenElement = (parent) => {
  const list = [];
  // 获取 NodeIterator 对象
  let t = document.createNodeIterator(
    parent,
    NodeFilter.SHOW_ELEMENT,
    null,
    false
  );
  let currNode = null;
  while ((currNode = t.nextNode()) !== null) {
    list.push(currNode);
  }
  return list;
};

// set window title
export const setWindowTitle = (newWindow, title) => {
  newWindow.onload = () => {
    if (
      !newWindow.document.getElementsByTagName("title") ||
      newWindow.document.getElementsByTagName("title").length === 0
    ) {
      const element = newWindow.document.createElement("title");
      newWindow.document.documentElement.appendChild(element);
    }
    const times = (30 * 1000) / 100;
    let count = 0;
    const interval = newWindow.setInterval(() => {
      if (count >= times) {
        newWindow.clearInterval(interval);
        return;
      }
      newWindow.document.getElementsByTagName("title")[0].innerText = title;
      count++;
    }, 100);
    newWindow.onunload = () => {
      newWindow.clearInterval(interval);
    };
  };
};

export const download = (url, filename) => {
  const element = document.createElement("a");
  element.download = filename;
  element.href = url;
  element.click();
};

export const openLink = (
  link,
  itemId,
  type,
  title,
  target = "_blank",
  isDownload,
  addTokenFlg
) => {
  if (!isEmpty(link)) {
    if (type === libraryTypeEnum.pdf) {
      // const authentication = getToken();
      let pdfLink;
      // if (authentication) {
      //   if (addTokenFlg === "1") {
      //     pdfLink =
      //       link +
      //       (link.indexOf("?") === -1 ? "?" : "&") +
      //       "&title=" +
      //       encodeURIComponent(title);
      //   } else {
      //     pdfLink =
      //       link +
      //       (link.indexOf("?") === -1 ? "?" : "&") +
      //       "key=" +
      //       authentication?.accountId +
      //       "&token=" +
      //       authentication?.token +
      //       "&title=" +
      //       encodeURIComponent(title);
      //   }
      // } else {
      pdfLink =
        link +
        (link.indexOf("?") === -1 ? "?" : "&") +
        "&title=" +
        encodeURIComponent(title);
      // }
      if (isDownload) {
        download(pdfLink, `${title}.pdf`);
      } else {
        const pdfWindow = getWindow().open(pdfLink, /*target || ""*/ "_blank");
        setWindowTitle(pdfWindow, title);
      }
    } else {
      getWindow().open(link, /*target || ""*/ "_blank");
    }
    if (itemId) {
      api.library.pdfLinkAccess({ itemId }).catch((error) => {
        console.error("error: " + error.message);
      });
    }
  }
};

// set url Parameter
export const setUrlParameter = (data = {}) => {
  const url = `${Object.keys(data)
    .map((item) => `${item}=${data[item]}`)
    .reduce(
      (previous, current, index) =>
        `${previous}${index !== 0 ? "&" : ""}${current}`,
      `${getWindow().location.origin}${getWindow().location.pathname}?`
    )}`;
  getWindow().history.replaceState(getWindow().history.state, "", url);
};

export const getUrlParameter = (search = "") => {
  const paramsList = search.substr(1).split("&");
  let params = {};
  paramsList.forEach((item) => {
    const items = item.split("=");
    params[items[0]] = items[1];
  });
  return params;
};

export const toEdge = () => {
  if (isIEBrowser()) {
    // IE
    // getWindow().location = "microsoft-edge:" + getWindow().location.href;
  }
};

export const substringEllipsis = (text, size = 6) => {
  if (isEmpty(text)) {
    return text;
  }
  return text.length > size ? `${text.substr(0, size)}...` : text;
};

// Parse html style string for a react component
export const convertStylesStringToObject = (stringStyles) =>
  typeof stringStyles === "string"
    ? stringStyles.split(";").reduce((acc, style) => {
        const colonPosition = style.indexOf(":");

        if (colonPosition === -1) {
          return acc;
        }

        const camelCaseProperty = style
            .substr(0, colonPosition)
            .trim()
            .replace(/^-ms-/, "ms-")
            .replace(/-./g, (c) => c.substr(1).toUpperCase()),
          value = style.substr(colonPosition + 1).trim();

        return value ? { ...acc, [camelCaseProperty]: value } : acc;
      }, {})
    : {};

// 課金-ADD-START
//  is POC env
export const isPOC = () => {
  return getWindow().location.origin === "https://poc-ex.trynibus-dev.com";
};
// 課金-ADD-END
